// app Controller
(function (angular, app) {
   "use strict";

   angular.module(app.modules.app.name).controller(app.modules.app.controller, appController);
   
   appController.$inject = ["$scope", "$location", "$window"
      , app.modules.common.constants.appsettings
      , app.modules.member.services.detail
      , app.modules.ui.services.branding
   ];
   
   function appController($scope, $location, $window, appSettings, ggMember, ggBranding) {

      var ctrl = this;
     
      if (!isCordova) {
          // Forcing Location Properties
          var isForced = false;
          var newURL = $location.absUrl();

          // Force SSL
          if (appSettings.forceSSL) {
              if ($location.protocol() !== 'https') {
                  isForced = true;
                  newURL = newURL.replace('http', 'https');
              }
          }

          // Force WWW
          if (appSettings.forceWWW) {
              var host = $location.host();
              var www = host.substring(0, 4).toLowerCase();
              if (www !== 'www.' && (newURL.indexOf("groupygolf.com") > -1)) {
                  isForced = true;
                  newURL = newURL.replace("://", "://www.");
              }
          }

          // No force for localhost.
          if (newURL.indexOf("localhost") > -1) {
              isForced = false;
          }

          if (isForced) {
              $window.location.href = newURL;
          }
      }


      // Create new member object to persist thru application
      app.Member = new ggMember.NewMember;
      app.Branding = new ggBranding.NewBrand;
      
      FastClick.attach(document.body);

      ctrl.appName = app.Branding.appName;

   };
   
}(angular, app)); 